
// @ts-nocheck

import { useEffect, useRef, useState } from "react";
import Trainers from "../components/Trainers";
import Outcomes from "../components/Outcomes";
import DesignedForPractice from "../components/DesignedForPractice";
import Liveprojectsection from "../components/Liveprojectsection";
import CertificateOutcomeSection from "../components/Certificateoutcomesection";

const highlights = [
  {
    title: "National and International Expert Trainers",
    alwaysOpen: true,
    detail: (
      <div>
        <p style={{ marginBottom: "1.2rem", color: "var(--stone)", fontSize: "0.85rem", fontWeight: 300, lineHeight: 1.7 }}>
          Learn from the experts in their fields with peronalised guidance
        </p>
        <div className="hl-stat-grid" style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "1.5px",
          background: "var(--sand)",
          marginBottom: 0,
        }}>
          <div className="hl-stat-cell" style={{
            display: "flex",
            alignItems: "center",
            gap: "1.3rem",
            background: "var(--charcoal)",
            padding: "1.8rem 2rem",
            minHeight: "90px",
          }}>
            <div style={{ color: "var(--terra-lt)", fontFamily: "var(--serif)", fontSize: "2.6rem", lineHeight: 1, flexShrink: 0 }}>2</div>
            <div style={{ minWidth: 0 }}>
              <div className="hl-stat-label" style={{ color: "var(--cream)", fontSize: "0.85rem", fontWeight: 600, whiteSpace: "nowrap" }}>International Guest faculties</div>
            </div>
          </div>
          <div className="hl-stat-cell" style={{
            display: "flex",
            alignItems: "center",
            gap: "1.3rem",
            background: "var(--charcoal)",
            padding: "1.8rem 2rem",
            minHeight: "90px",
          }}>
            <div style={{ color: "var(--terra-lt)", fontFamily: "var(--serif)", fontSize: "2.6rem", lineHeight: 1, flexShrink: 0 }}>8</div>
            <div style={{ minWidth: 0 }}>
              <div className="hl-stat-label" style={{ color: "var(--cream)", fontSize: "0.85rem", fontWeight: 600, whiteSpace: "nowrap" }}>Industry Professionals</div>
            </div>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Max 20 Students per batch",
    detail: (
      <div>
        <p style={{ color: "var(--stone)", fontSize: "0.85rem", fontWeight: 300, lineHeight: 1.7 }}>
          Small batch sizes mean every student gets direct, personalised feedback from trainers — not lost in a crowd of hundreds.
        </p>
      </div>
    ),
  },
  {
    title: "AI-Powered Architecture Tools",
    detail: (
      <div>
        <p style={{ color: "var(--stone)", fontSize: "0.85rem", fontWeight: 300, lineHeight: 1.7 }}>
          Hands-on training across AutoCAD, Revit/BIM, SketchUp, and AI-driven design & visualization tools. AI is reshaping how buildings are designed, documented, and delivered — this program makes sure you adopt that technology early instead of catching up to it later.
        </p>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "1.6rem", marginTop: "1.2rem", marginBottom: "1.4rem" }}>
          {[
            { name: "Revit", src: "/assets/img/revit-logo.png" },
            { name: "Grasshoper", src: "/assets/img/Grasshoper.png" },
            { name: "Autocad", src: "/assets/img/autocad.png" },
            // { name: "Vector works", src: "/assets/img/vectorworks.png" },
            { name: "Rhino", src: "/assets/img/Rhino.png" },
          ].map((sw) => (
            <div key={sw.name} style={{ textAlign: "center", width: "80px" }}>
              <img src={sw.src} alt={sw.name} style={{ maxWidth: "80px", marginBottom: "0.4rem" }} />
              <div style={{ color: "var(--stone)", fontSize: "0.72rem", fontWeight: 500 }}>{sw.name}</div>
            </div>
          ))}
        </div>
      </div>
    ),
  },
  {
    title: "350 Hours Live Sessions",
    detail: "Real-time, instructor-led classes — not pre-recorded videos. Ask questions, get reviewed live, and learn alongside your batch.",
  },
  {
    title: "Customized Program for Each Candidate",
    detail: "Your learning path is shaped around your existing strengths and the gaps you want to close — not a one-size-fits-all syllabus.",
  },
];

// Max-height (px) of the open accordion panel, per highlight index.
// Indices with richer content (stat cards / lists / software icons) need more room.
const HL_OPEN_HEIGHTS = { 0: 280, 1: 200, 2: 480 };

// Country codes for the mobile-number field. Add/remove entries here — the
// dropdown in AdmissionForm renders from this list, so it stays dynamic.

const countryCodes = [
  { code: "+91", label: "IN +91", minLength: 10, maxLength: 10 },
  { code: "+1", label: "US +1", minLength: 10, maxLength: 10 },
  { code: "+44", label: "UK +44", minLength: 10, maxLength: 10 },
  { code: "+61", label: "AU +61", minLength: 9, maxLength: 9 },
  { code: "+971", label: "AE +971", minLength: 9, maxLength: 9 },
  { code: "+65", label: "SG +65", minLength: 8, maxLength: 8 },
  { code: "+974", label: "QA +974", minLength: 8, maxLength: 8 },
  { code: "+966", label: "SA +966", minLength: 9, maxLength: 9 },
  { code: "+27", label: "ZA +27", minLength: 9, maxLength: 9 },
  { code: "+49", label: "DE +49", minLength: 11, maxLength: 11 },
];

const growthCards = [
  {
    title: " Project Execution Confidence",
    text: "Develop the confidence to independently manage architectural projects from concept to completion.",
    icon: (<svg viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" /></svg>),
  },
  {
    title: " Real Industry Exposure",
    text: "Learn how architecture firms actually work through practical workflows, live projects, and expert mentoring.",
    icon: (<svg viewBox="0 0 24 24"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" /></svg>),
  },
  {
    title: "Future-Ready Skills",
    text: "Stay ahead with AI-powered workflows, industry tools, and evolving technologies shaping the future of architecture.",
    icon: (<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M9 21V9" /></svg>),
  },
  {
    title: "Professional Growth",
    text: "Strengthen your communication, leadership, presentation, and client management skills to grow as a professional.",
    icon: (<svg viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c3 3 9 3 12 0v-5" /></svg>),
  },
  {
    title: "Self Evaluate",
    text: "Make sharper, better-informed career decisions for the long term.",
    icon: (<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4" /><path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" /><path d="M12 12v6" /></svg>),
  },
  {
    title: "Professional Network",
    text: "Build a strong, lasting network of peers, alumni and IPDI mentors.",
    icon: (<svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>),
  },
];

/* ── Course Structure content — identical to the original data ── */

// Grouped software data used by the "Advance Architecture Softwares"
// module — same tools that were already in courseStructure, just
// organised into categories for the card-grid UI.
const softwareGroups = [
  {
    category: "BIM & Building Information Modeling",
    icon: "bim",
    tools: [
      { name: "Advance Revit Architecture", subtitle: "BIM Modeling", icon: "revit" },
      { name: "Navisworks", subtitle: "Model Coordination", icon: "navisworks" },
    ],
  },
  {
    category: "Visualization & Presentation",
    icon: "eye",
    tools: [
      { name: "Sketch Up", subtitle: "3D Modeling", icon: "sketchup" },
      { name: "V-Ray", subtitle: "Rendering Engine", icon: "vray" },
    ],
  },
  {
    category: "Architecture AI Software",
    icon: "ai",
    tools: [
      { name: "Enscape", subtitle: "Real-time Rendering", icon: "enscape" },
      { name: "D5 Render", subtitle: "Real-time Rendering", icon: "d5render" },
      { name: "Nano Banana", subtitle: "AI Rendering", icon: "nanobanana" },
    ],
  },
  {
    category: "Urban Planning & GIS",
    icon: "globe",
    tools: [
      { name: "ArcGIS", subtitle: "Spatial Analysis", icon: "arcgis" },
      { name: "Global Mapper", subtitle: "Terrain & Mapping", icon: "globalmapper" },
    ],
  },
  {
    category: "Computational Design",
    icon: "computational",
    tools: [
      { name: "Rhino", subtitle: "Parametric Modeling", icon: "rhino" },
      { name: "Grasshopper", subtitle: "Algorithmic Design", icon: "grasshopper" },
    ],
  },
];

// Generic block headings (Program structure, Course Objectives, Services…)
// are rendered with the same category-header treatment as the software
// groups above. This maps a heading to the icon used in that header.
function blockIconType(heading) {
  if (heading === "Course Objectives") return "target";
  if (heading === "Services") return "layers";
  return "list";
}

function CategoryIcon({ type }) {
  const p = {
    bim: <path d="M4 21V8l8-5 8 5v13M9 21v-7h6v7M4 8l8 5 8-5" />,
    eye: (
      <>
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
        <circle cx="12" cy="12" r="3" />
      </>
    ),
    globe: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
      </>
    ),
    computational: (
      <>
        <circle cx="6" cy="6" r="2.4" />
        <circle cx="18" cy="6" r="2.4" />
        <circle cx="12" cy="18" r="2.4" />
        <path d="M8 7l7 0M7.5 8.2L11 16M16.5 8.2L13 16" />
      </>
    ),
    ai: (
      <>
        <rect x="4" y="7" width="16" height="12" rx="2.5" />
        <circle cx="9" cy="13" r="1.3" />
        <circle cx="15" cy="13" r="1.3" />
        <path d="M12 7V4M9 4h6" />
      </>
    ),
    // ── generic block-header icons used for Program structure /
    // Course Objectives / Services / any other plain item block ──
    list: <path d="M4 6h16M4 12h10M4 18h13" />,
    target: (
      <>
        <circle cx="12" cy="12" r="8.5" />
        <circle cx="12" cy="12" r="4.5" />
        <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
      </>
    ),
    layers: (
      <>
        <path d="M12 3l9 5-9 5-9-5 9-5z" />
        <path d="M3 13l9 5 9-5" />
      </>
    ),
  };
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      {p[type] ?? p.bim}
    </svg>
  );
}

// Per-tool icon tint (background + foreground) so each card's icon chip
// roughly matches the reference screenshots.
const TOOL_ICON_THEME = {
  revit:        { bg: "rgba(59,130,246,0.12)",  fg: "#2f6fed" },
  navisworks:   { bg: "rgba(16,185,129,0.12)",  fg: "#1f9d55" },
  sketchup:     { bg: "rgba(59,130,246,0.12)",  fg: "#2f6fed" },
  vray:         { bg: "rgba(239,68,68,0.12)",   fg: "#e0362b" },
  enscape:      { bg: "rgba(249,115,22,0.14)",  fg: "#e0692a" },
  d5render:     { bg: "rgba(168,85,247,0.14)",  fg: "#8b3dd6" },
  nanobanana:   { bg: "rgba(234,179,8,0.16)",   fg: "#c99a06" },
  arcgis:       { bg: "rgba(16,185,129,0.12)",  fg: "#1f9d55" },
  globalmapper: { bg: "rgba(59,130,246,0.12)",  fg: "#2f6fed" },
  rhino:        { bg: "rgba(120,113,108,0.14)", fg: "#57534e" },
  grasshopper:  { bg: "rgba(16,185,129,0.12)",  fg: "#1f9d55" },
};

function ToolIcon({ type }) {
  const p = {
    revit: <path d="M4 20V6l8-3 8 3v14M8 20v-6h8v6M4 10h16" />,
    navisworks: (
      <>
        <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z" />
        <path d="M4 7.5L12 12l8-4.5M12 12v9" />
      </>
    ),
    sketchup: <path d="M4 8l8-5 8 5-8 5-8-5zM4 8v8l8 5V13M20 8v8l-8 5" />,
    vray: <path d="M4 5l6 14h4L20 5M9 5l3 8 3-8" />,
    enscape: (
      <>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
      </>
    ),
    d5render: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M10 8l6 4-6 4V8z" />
      </>
    ),
    nanobanana: <path d="M4 20l3-1 11-11a2 2 0 0 0-3-3L4 16l-1 4z" />,
    arcgis: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
      </>
    ),
    globalmapper: (
      <>
        <path d="M12 21s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12z" />
        <circle cx="12" cy="9" r="2.4" />
      </>
    ),
    rhino: <path d="M6 4v16M6 4l10 4-10 4M6 12l10 4-10 4" />,
    grasshopper: (
      <>
        <circle cx="6" cy="6" r="2.2" />
        <circle cx="18" cy="6" r="2.2" />
        <circle cx="12" cy="18" r="2.2" />
        <path d="M8 6.5h8M7.7 7.8L11.5 16M16.3 7.8L12.5 16" />
      </>
    ),
  };
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {p[type] ?? p.revit}
    </svg>
  );
}

// Renders the grouped software cards (category header + 2-col grid of
// tool cards) used inside the "Advance Architecture Softwares" module.
function SoftwareGroups({ groups }) {
  return (
    <div className="sw-groups">
      {groups.map((g) => (
        <div className="sw-category" key={g.category}>
          <div className="sw-cat-header">
            <span className="sw-cat-icon"><CategoryIcon type={g.icon} /></span>
            <span className="sw-cat-title">{g.category}</span>
            <span className="sw-cat-line" />
          </div>
          <div className="sw-grid">
            {g.tools.map((t) => {
              const theme = TOOL_ICON_THEME[t.icon] ?? TOOL_ICON_THEME.revit;
              return (
                <div className="sw-card" key={t.name}>
                  <span className="sw-card-icon" style={{ background: theme.bg, color: theme.fg }}>
                    <ToolIcon type={t.icon} />
                  </span>
                  <span className="sw-card-text">
                    <span className="sw-card-title">{t.name}</span>
                    <span className="sw-card-sub">{t.subtitle}</span>
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

// Renders a plain item block (Program structure / Course Objectives /
// Services / etc.) using the SAME category-header + card-grid treatment
// as the software groups above: an icon chip + title + rule line up top,
// then a 2-column grid of item cards below.
//
// Sub-items (A. / B. / C. lines) render WITHOUT the leading icon/dot and
// span the full row (grid-column: 1 / -1) so they stack one under the
// other, with just a bottom border (see .csg-item-card.sub in CSS below).
function ItemBlockGroup({ heading, note, items }) {
  return (
    <div className="sw-groups">
      <div className="sw-category">
        <div className="sw-cat-header">
          <span className="sw-cat-icon">
            <CategoryIcon type={blockIconType(heading)} />
          </span>
          <span className="sw-cat-title">{heading ?? "What you'll cover"}</span>
          {/* <span className="sw-cat-line" /> */}
        </div>

        {note ? <p className="csg-card-note">{note}</p> : null}

        <div className="sw-grid">
          {items.map((li) => {
            const sub = isSub(li);
            return (
              <div className={`sw-card csg-item-card${sub ? " sub" : ""}`} key={li}>
                {!sub && (
                  <span className="sw-card-icon csg-item-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4.5 12.5l4.5 4.5L19.5 6.5" />
                    </svg>
                  </span>
                )}
                <span className="sw-card-text">
                  <span className="sw-card-title csg-item-text">{li}</span>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

const courseStructure = [
  {
    title: "Career Counselling and Guidance",
    duration: "3 days",
    icon: "compass",
    blocks: [
      { heading: "Career Counselling", items: ["Career Counselling", "Career Guidance"] },
      {
        heading: "Course Objectives",
        items: [
          "Make the candidates know their own self",
          "Enhance their inner core strengths, minimize weaknesses, and identify interests",
          "Guidance for choosing the correct path in career",
          "Direction to use the acquired strength in the right direction",
          "Prevent one from work-related stress",
        ],
      },
    ],
  },
//   {
//     title: "Soft Skills Development",
//     duration: "1 week",
//     icon: "users",
//     blocks: [
//       {
//         heading: "Program structure",
//         items: [
//           "Improve Communication and Self-Marketing skills",
//           "Enhance Interactive Skills",
//           "Build a Positive Competitive attitude",
//           "Induce right Work Ethics",
//           "Build Human Relations",
//           "Learn Time Management",
//         ],
//       },
//     ],
//   },


{
  title: "Soft Skills Development",
  duration: "1 week",
  icon: "users",
  blocks: [

 {
      heading: "What They'll Learn",
      items: [
        "Business Communication",
        "Interpersonal skills",
        "Time Management",
        "Positive Competitive attitude",
        "Work Ethics",
      ],
    },

    {
      heading: "Program structure",
      items: [
        "Improve Communication and Self-Marketing skills",
        "Enhance Interactive Skills",
        "Build a Positive Competitive attitude",
        "Induce right Work Ethics",
        "Build Human Relations",
        // "Learn Time Management",
      ],
    },
   
  ],
},

  {
    title: "Architecture Drawings & Services Standards",
    duration: "3 weeks",
    icon: "ruler",
    blocks: [
      {
        heading: "Program structure",
        items: [
          "Auto CAD Drafting Standards",
          "Introduction to Types of Drawing for building execution",
          "Working Drawings standards",
          "Folder Management",
          "Virtual Tour for explaining On-site execution",
        ],
      },
      {
        heading: "Course Objectives",
        items: [
          "Renewed confidence in your technical drawing skills",
          "To learn technical drawings as per industry standards",
          "To understand onsite execution problems and their solution",
        ],
      },
      {
        heading: "Services",
        note: "In-depth understanding of Building Services and their varied functions.",
        items: [
          "A. Electrical",
          "B. Mechanical",
          "C. Plumbing",
          "Basic consideration of services and how to implement them in their design",
          "Preparing service drawings",
          "On-site and off-site Consultant coordination",
        ],
      },
      {
        heading: "Course Objectives",
        items: [
          "To understand services and learn to produce their drawings",
          "To understand various types of services and consultant teams' coordination",
          "To understand onsite execution problems and work out solutions",
        ],
      },
    ],
  },


  {
  title: "Advance Architecture Softwares",
  duration: "12 weeks",
  icon: "cube",
  blocks: [
    {
      type: "software-groups",
      groups: softwareGroups,
    },
    {
      heading: "Personalized Software Learning",
      note: "Unlike traditional institutes, we don't teach every software to every learner. Based on your career goals, strengths, and specialization, our mentors design a personalized learning path and train you only in the tools that matter for your profession.",
      items: [
        "Want to specialize in BIM? Focus on BIM tools",
        "Interested in Urban Planning or Master Planning? Learn tools like ArcGIS",
        "Goal is Visualization? Work with rendering and presentation software",
      ],
    },
    {
      heading: "Course Objectives",
      items: [
        "Develop Advanced Software skills",
        "Enhance Productivity",
        "Construct a bridge between Design and Technology",
        "Improve Design and Presentation skills",
        "Minimize time between Design to Execution Drawings",
        "Increased job opportunities on a global platform",
      ],
    },
  ],
},

  {
    title: "Advance Construction Technologies & Materials",
    duration: "1 week",
    icon: "brick",
    blocks: [
      {
        heading: "Program structure",
        items: [
          "Introduction to Current Construction Technologies and Trends",
          "Introduction to Latest construction materials",
          "Role of materials in a building envelope",
          "A brief introduction to LEED certifications",
          "A brief overview of Sustainable building materials",
        ],
      },
      {
        heading: "Course Objectives",
        items: [
          "To develop knowledge about new construction techniques and materials",
          "To improve overall design skills",
          "To create an awareness of sustainable development in the industry",
          "To initiate the process of innovative thinking ability with the help of different materials and advanced technologies",
        ],
      },
    ],
  },
  {
    title: "NBC & Liasoning",
    duration: "1 week",
    icon: "shield",
    blocks: [
      {
        heading: "Program structure",
        items: [
          "A brief introduction about NBC",
          "Fire norms",
          "Liasoning",
          "Building permission & required documents",
          "Development plan",
          "Regional plan",
          "List of documents required for sanction process",
          "Guidelines to read legal documents",
          "Know-how's of Sanction process",
          "Provide a brief understanding of Purpose and need of various documents",
          "Types of NOC",
        ],
      },
      {
        heading: "Course Objectives",
        items: [
          "Awareness of NBC (National Building Code) Standards",
          "Importance of National and International Building Codes in Architectural Practice",
          "To improve Design Skills",
          "Awareness of Building Bylaws",
          "Importance of Building Bylaws",
        ],
      },
    ],
  },
  {
    title: "Live Project Enrolment",
    duration: "7 weeks",
    icon: "crane",
    blocks: [
      {
        heading: "Program structure",
        items: [
          "An Introduction about Live Project and its Management",
          "Interactions with Site-coordinators",
          "Involvement in Live Projects",
          "Working Drawings",
          "Coordination between various Consultants",
          "Service Layouts and Drawings",
        ],
      },
      {
        heading: "Course Objectives",
        items: [
          "To provide hands-on experience to the candidates",
          "To make the candidate technically sound",
          "To offer a real-time experience of how a project works",
          "To build confidence to handle project and people on site from scratch to end",
          "To train candidates to work on a project single-handedly from start to end",
        ],
      },
    ],
  },
  {
    title: "Placement Assistance",
    duration: "3 days workshop",
    icon: "briefcase",
    blocks: [
      {
        heading: "Program structure",
        items: ["Assistance in forming a Portfolio", "Assistance in preparing a Resume/CV"],
      },
    ],
  },
];

const outcomeCards = [
  "Critical thinking skills",
  "Practical Approach toward design",
  "Professional Skills",
  "Communication skills",
  "Broader Vision",
  "The ability to execute your own ideas",
  "Ability to coordinate multidisciplinary teams",
  "Build Confidence",
];

const programFeeItems = [
  "350 hours live session",
  "National and international guest faculty",
  "5 advance software training",
  "Access to Job Portal",
  "Resume and Portfolio Building",
  "Interview Preparation",
  "Scheduling Interviews By IPDI HR Team",
];

const VALID_TABS = ["overview", "instructors", "structure", "outcome", "admissions", "enroll"];

function getTabFromHash() {
  if (typeof window === "undefined") return "overview";
  const hash = window.location.hash.replace("#", "");
  return VALID_TABS.includes(hash) ? hash : "overview";
}

function CheckIcon() {
  return (<svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" /></svg>);
}

// Same up/down chevron markup used in the Angular highlights accordion
// (*ngIf-swapped svgs, viewBox 0 0 24 14, black stroke).
function ChevronIcon({ open }) {
  if (open) {
    return (
      <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22 12L12 2L2 12"
          stroke="black"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 2L12 12L2 2"
        stroke="black"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function HeroIcon({ type }) {
  if (type === "duration") {
    return (<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></svg>);
  }
  if (type === "classes") {
    return (<svg viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></svg>);
  }
  return (<svg viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c3 3 9 3 12 0v-5" /></svg>);
}

// Data for the "Why This Program Is Different" cards.
const diffCards = [
  {
    old: "Fixed syllabus",
    new: "Personalized learning path",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 20l9-16H3l9 16z" />
      </svg>
    ),
  },
  {
    old: "Software-focused",
    new: "Complete professional development",
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M3 9h18" />
      </svg>
    ),
  },
  {
    old: "Classroom assignments",
    new: "Live industry exposure",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
      </svg>
    ),
  },
  {
    old: "Learn individual tools",
    new: "Learn the entire project lifecycle",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
        <path d="M6 12v5c3 3 9 3 12 0v-5" />
      </svg>
    ),
  },
  {
    old: "Generic teaching",
    new: "Mentorship from practicing architects",
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
      </svg>
    ),
  },
  {
    old: "Certificate-oriented",
    new: "Career and practice readiness",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 15l-2 5 2-1 2 1-2-5z" />
        <circle cx="12" cy="8" r="6" />
      </svg>
    ),
  },
];

function WhyDifferentSection() {
  return (
    <section className="diff" id="why-different">
      <style>{`
        .diff {
          max-width: 1400px;
          margin: 0 auto;
          padding: 4rem 2.5rem 6rem;
        }
        .diff-hdr {
          max-width: 66ch;
          margin-bottom: 3rem;
        }
        .diff-hdr .sec-sub {
          margin-top: 1rem;
        }

        .diff-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.5px;
          background: var(--sand);
        }
        .diff-card {
          background: #fff;
          padding: 2.2rem 2rem;
          display: flex;
          flex-direction: column;
          gap: 1rem;
          transition: background 0.3s;
        }
        .diff-card:hover {
          background: var(--cream);
        }
        .diff-icon {
          width: 2.4rem;
          height: 2.4rem;
          background: rgba(184, 92, 40, 0.12);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .diff-icon svg {
          width: 14px;
          height: 14px;
          stroke: var(--terra);
          fill: none;
          stroke-width: 1.8;
        }
        .diff-old-line {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.78rem;
          color: var(--stone-lt);
          font-weight: 300;
          text-decoration: line-through;
          text-decoration-color: var(--sand);
        }
        .diff-new-line {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.95rem;
          color: var(--charcoal);
          font-weight: 600;
        }

        @media (max-width: 900px) {
          .diff-cards {
            grid-template-columns: 1fr 1fr;
          }
        }
        @media (max-width: 640px) {
          .diff-cards {
            grid-template-columns: 1fr;
          }
            .diff {
              padding: 5rem 1.2rem 3rem}
        }
      `}</style>

      <div className="diff-hdr rv">
        <div className="eyebrow">
          <div className="eyebrow-dash" />
          <span className="eyebrow-text">The Difference</span>
        </div>
        <h2 className="sec-title">
          Why This Program Is <em>Different</em>
        </h2>
        <p className="sec-sub">
          Most training stops at software. We built a program around the entire
          arc of becoming a practicing architect — from a client brief to a
          handed-over project.
        </p>
      </div>

      <div className="diff-cards rv d1">
        {diffCards.map((card) => (
          <div className="diff-card" key={card.old}>
            <div className="diff-icon" aria-hidden="true">
              {card.icon}
            </div>
            <div className="diff-old-line">{card.old}</div>
            <div className="diff-new-line">{card.new}</div>
          </div>
        ))}
      </div>
    </section>
  );
}


const namePattern = /^[A-Za-z\s.'-]+$/;

function AdmissionForm({ sectionId, reveal }) {
  const [countryCode, setCountryCode] = useState("+91");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    city: "",
    qualification: "",
  });
  const [errors, setErrors] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//         if (["firstName", "lastName"].includes(name) && value.trim() && !namePattern.test(value)) {
//             setErrors((prev) => ({ ...prev, [name]: "Name can contain letters only" }));
//         } else if (errors[name]) {
//       setErrors((prev) => ({ ...prev, [name]: "" }));
//     }
//   };


const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "mobile") {
    const selectedCountry = countryCodes.find(
      (country) => country.code === countryCode
    );

    const maxLength = selectedCountry?.maxLength || 15;

    const mobileValue = value
      .replace(/\D/g, "")
      .slice(0, maxLength);

    setFormData((prev) => ({
      ...prev,
      mobile: mobileValue,
    }));

    if (errors.mobile) {
      setErrors((prev) => ({
        ...prev,
        mobile: "",
      }));
    }

    return;
  }

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  if (
    ["firstName", "lastName"].includes(name) &&
    value.trim() &&
    !namePattern.test(value)
  ) {
    setErrors((prev) => ({
      ...prev,
      [name]: "Name can contain letters only",
    }));
  } else if (errors[name]) {
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  }
};

  const validate = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "Please enter your first name";
        } else if (!namePattern.test(formData.firstName.trim())) {
            newErrors.firstName = "Name can contain letters only";
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Please enter your last name";
        } else if (!namePattern.test(formData.lastName.trim())) {
            newErrors.lastName = "Name can contain letters only";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Please enter your email ID";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      newErrors.email = "Enter a valid email address";
    }
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Please enter your mobile number";
    } else {
  const selectedCountry = countryCodes.find(
    (country) => country.code === countryCode
  );

  const minLength = selectedCountry?.minLength || 8;
  const maxLength = selectedCountry?.maxLength || 15;
  const mobile = formData.mobile.trim();

  if (mobile.length < minLength || mobile.length > maxLength) {
    if (minLength === maxLength) {
      newErrors.mobile = `Enter a valid ${minLength}-digit number`;
    } else {
      newErrors.mobile = `Enter a valid mobile number (${minLength}-${maxLength} digits)`;
    }
  }
}


    if (!formData.city.trim()) {
      newErrors.city = "Please select your city";
    }
    if (!formData.qualification) {
      newErrors.qualification = "Please select your qualification";
    }

    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async () => {
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    const payload = {
      ...formData,
      mobileCode: countryCode,
      formName: "Executive Architect",
    };

    try {
      setSubmitting(true);
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/programEA/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok) {
        setShowSuccess(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          city: "",
          qualification: "",
        });
        setErrors({});
      } else {
        setErrors((prev) => ({ ...prev, _server: "Something went wrong. Please try again." }));
        console.error("Server responded with error:", data);
      }
    } catch (err) {
      console.error(err);
      setErrors((prev) => ({ ...prev, _server: "Something went wrong. Please try again." }));
    } finally {
      setSubmitting(false);
    }
  };

  const errorMsgStyle = {
    color: "#ff6b6b",
    fontSize: "0.75rem",
    marginTop: "4px",
    display: "block",
    lineHeight: 1.3,
  };

  const fieldWrapperStyle = {
    marginBottom: "1rem",
  };

  const fieldStyle = (name, extra = {}) => ({
    fontSize: "0.95rem",
    border: errors[name] ? "1px solid #ff4d4d" : undefined,
    width: "100%",
    ...extra,
  });

  const rv = reveal ? " rv" : "";

  return (
    <section className="fee-apply" id={sectionId}>
      <div className={`fee-box${rv}`}>
        <div className="fee-lbl" style={{ fontSize: "16px" }}>EMI Start from</div>
        <div className="fee-amt" style={{ fontSize: "2rem" }}>
          INR{" "}
          <span style={{ fontFamily: "inherit", fontSize: "3rem", fontWeight: 400, color: "#fff" }}>
            4990
          </span>
          <span style={{ fontFamily: "inherit", fontSize: "1.2rem", fontWeight: 400, color: "var(--stone-lt)" }}>
            {" "}/ Month *
          </span>
        </div>
        <div className="fee-incl-t" style={{ color: "var(--terra-lt)", marginTop: "2.2rem", fontSize: "1.02rem" }}>
          6 month professional training program includes
        </div>
        <div className="fee-list" style={{ marginTop: "1.3rem" }}>
          {programFeeItems.map((item) => (
            <div className="fee-row" key={item} style={{ fontSize: "1rem" }}>
              <CheckIcon />{item}
            </div>
          ))}
        </div>
        <div style={{ marginTop: "2.2rem", paddingTop: "1.6rem", borderTop: "1px solid rgba(255,255,255,0.12)" }}>
          <span style={{ color: "#fff", fontFamily: "var(--serif)", fontSize: "2rem", fontWeight: 300 }}>
            Program fee INR{" "}
            <span
              style={{
                fontSize: "2.8rem",
                fontWeight: 400,
                fontFamily: "inherit",
                color: "#fff",
                lineHeight: 1,
                display: "inline-block",
              }}
            >
              69,000
            </span>{" "}
            /-
          </span>
        </div>
      </div>

      {/* <div className={`apply-box${rv ? `${rv} d1` : ""}`} id={sectionId === "admissions" ? "apply" : undefined}> */}

<div className={`apply-box${rv ? `${rv} d1` : ""}`} id={sectionId === "enroll" ? "apply" : undefined}>

        <div className="apply-eyebrow" style={{ fontSize: "0.68rem" }}>Take the First Step</div>
        <div className="apply-title" style={{ fontSize: "1.7rem" }}>Executive Architect</div>
        <div className="apply-sub" style={{ marginTop: 0, fontSize: "0.8rem" }}>Personal Information</div>

        {errors._server && (
          <div style={{ color: "#ff6b6b", fontSize: "0.8rem", marginBottom: "0.8rem" }}>
            {errors._server}
          </div>
        )}

        <div className="apply-row" style={{ gap: "1rem" }}>
          <div style={fieldWrapperStyle}>
            <input
              className="apply-field"
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="First name *"
              style={fieldStyle("firstName")}
            />
            {errors.firstName && <span style={errorMsgStyle}>{errors.firstName}</span>}
          </div>
          <div style={fieldWrapperStyle}>
            <input
              className="apply-field"
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Last name *"
              style={fieldStyle("lastName")}
            />
            {errors.lastName && <span style={errorMsgStyle}>{errors.lastName}</span>}
          </div>
        </div>

        <div style={fieldWrapperStyle}>
          <input
            className="apply-field"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email ID *"
            style={fieldStyle("email")}
          />
          {errors.email && <span style={errorMsgStyle}>{errors.email}</span>}
        </div>

        <div style={fieldWrapperStyle}>
          <div className="apply-phone">
            <select
              className="apply-code-select"
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
              aria-label="Country code"
            >
              {countryCodes.map((c) => (
                <option key={c.code} value={c.code}>
                  {c.code}
                </option>
              ))}
            </select>
            {/* <input
              className="apply-field apply-field-phone"
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Mobile no. *"
              style={fieldStyle("mobile")}
            /> */}

<input
  className="apply-field apply-field-phone"
  type="tel"
  name="mobile"
  value={formData.mobile}
  onChange={handleChange}
  placeholder="Mobile no. *"
  maxLength={
    countryCodes.find(
      (country) => country.code === countryCode
    )?.maxLength || 15
  }
  inputMode="numeric"
  style={fieldStyle("mobile")}
/>

          </div>
          {errors.mobile && <span style={errorMsgStyle}>{errors.mobile}</span>}
        </div>

        <div style={fieldWrapperStyle}>
          <input
            className="apply-field"
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="City *"
            style={fieldStyle("city")}
          />
          {errors.city && <span style={errorMsgStyle}>{errors.city}</span>}
        </div>

        <div className="apply-sub" style={{ fontSize: "0.8rem" }}>Qualification</div>
        <div style={fieldWrapperStyle}>
          <select
            className="apply-select"
            value={formData.qualification}
            name="qualification"
            onChange={handleChange}
            style={fieldStyle("qualification", { marginBottom: "0 !important" })}
          >
            <option value="" disabled>Select degree</option>
            <option>Bachelor of Architecture</option>
            <option>Diploma in Architecture</option>
            <option>Pursuing B.Arch (Final Year)</option>
            <option>Other</option>
          </select>
          {errors.qualification && <span style={errorMsgStyle}>{errors.qualification}</span>}
        </div>

        <button
          className="apply-btn"
          type="button"
          onClick={handleSubmit}
          disabled={submitting}
          style={{ fontSize: "0.85rem" }}
        >
          {submitting ? "Submitting..." : "Start Application"}
        </button>
      </div>

      {showSuccess ? (
        <div className="success-popup-overlay" onClick={() => setShowSuccess(false)}>
          <div className="success-popup-card" onClick={(event) => event.stopPropagation()}>
            <div className="success-popup-icon">
              <svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" /></svg>
            </div>
            <div className="success-popup-title">Application Submitted</div>
            <p className="success-popup-text">
              Thanks for applying to IPDI! Our admissions team will reach out to you shortly on the details you shared.
            </p>
            <button className="success-popup-btn" type="button" onClick={() => setShowSuccess(false)}>
              Done
            </button>
          </div>
        </div>
      ) : null}
    </section>
  );
}

const admissionProcessSteps = [
  {
    n: "01",
    t: "Fill the Enrollment Form",
    d: "Share your basic details to begin your application with IPDI.",
  },
  {
    n: "02",
    t: "Block Your Seat",
    d: "Reserve your seat in the program with a nominal advance payment.",
  },
  {
    n: "03",
    t: "Complete Your Admission Form",
    d: "Complete your admission form and submit all required documents.",
  },
  {
    n: "04",
    t: "Complete the Payment",
    d: "Clear the balance program fee to confirm your enrollment.",
  },
  {
    n: "05",
    t: "Get Your Login Details",
    d: "Receive your login ID and password to start your online program.",
  },
];

function AdmissionProcessSection() {
  return (
    <section className="adm-process">
      <style>{`
        .adm-process {
          padding: 5rem 4rem 5rem 2.5rem;
          max-width: 1180px;
          margin: 0 ;
        }
        .adm-process-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 1.8rem;
          margin-top: 3rem;
          position: relative;
        }
        .adm-process-grid::before {
          content: "";
          position: absolute;
          top: 26px;
          left: 5%;
          right: 5%;
          height: 2px;
          background: repeating-linear-gradient(
            to right,
            var(--sand, #e7e1d8) 0px,
            var(--sand, #e7e1d8) 6px,
            transparent 6px,
            transparent 12px
          );
          z-index: 0;
        }
        .adm-step {
          background: #fff;
          border: 1px solid var(--sand, #e7e1d8);
          border-radius: 10px;
          padding: 2rem 1.5rem 1.8rem;
          position: relative;
          z-index: 1;
          transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;
        }
        .adm-step:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(28, 26, 23, 0.12);
          border-color: #c84b20;
        }
        .adm-step-badge {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: var(--charcoal, #1c1a17);
          color: #f4efe6;
          font-family: var(--serif);
          font-size: 1.4rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.3rem;
          transition: background 0.35s ease, transform 0.35s ease;
          position: relative;
        }
        .adm-step:hover .adm-step-badge {
          background: #c84b20;
          transform: scale(1.08);
        }
        .adm-step-t {
          font-weight: 600;
          font-size: 0.95rem;
          color: var(--charcoal, #1c1a17);
          line-height: 1.4;
          transition: color 0.3s ease;
        }
        .adm-step:hover .adm-step-t {
          color: #c84b20;
        }
        .adm-step-d {
          margin-top: 0.6rem;
          font-size: 0.82rem;
          color: var(--stone, #7d766c);
          font-weight: 300;
          line-height: 1.6;
        }
        @media (max-width: 900px) {
          .adm-process-grid { grid-template-columns: repeat(2, 1fr); }
          .adm-process-grid::before { display: none; }
        }
        @media (max-width: 560px) {
          .adm-process-grid { grid-template-columns: 1fr; }
          .adm-process { padding: 3rem 1.25rem 2rem; }
        }
        @media (min-width: 1200px) {
          .architect-theme .adm-process {
            width: min(1400px, calc(100% - 5rem));
            max-width: 1400px;
            margin-left: auto;
            margin-right: auto;
          }
        }
      `}</style>
      <div className="eyebrow rv">
        <div className="eyebrow-dash" />
        <span className="eyebrow-text">Simple &amp; Fast</span>
      </div>
      <h2 className="sec-title rv d1">
        Admission <em>Process</em>
      </h2>
      <div className="adm-process-grid">
        {admissionProcessSteps.map((step) => (
          <div className="adm-step" key={step.n}>
            <div className="adm-step-badge">{step.n}</div>
            <div className="adm-step-t">{step.t}</div>
            <div className="adm-step-d">{step.d}</div>
          </div>
        ))}
      </div>
    </section>
  );
}


/* ══════════════════════════════════════════════════════════════
   COURSE STRUCTURE — redesigned module accordion (icon rail + grid)
   Every block (Program structure, Course Objectives, Services, and
   the software groups) now shares the SAME category-header +
   card-grid presentation. Content is unchanged; this only changes
   presentation.
══════════════════════════════════════════════════════════════ */

function ModuleIcon({ type }) {
  const p = {
    compass: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M15 9l-2.2 5.3L7.5 16.5l2.2-5.3L15 9z" />
      </>
    ),
    users: (
      <>
        <circle cx="9" cy="8" r="3.2" />
        <path d="M3.5 20v-1.6A4 4 0 0 1 7.5 14.4h3A4 4 0 0 1 14.5 18.4V20" />
        <path d="M16.5 6.4a3.2 3.2 0 0 1 0 6.2M18 20v-1.6a4 4 0 0 0-2.2-3.5" />
      </>
    ),
    ruler: (
      <>
        <path d="M3 16.5L16.5 3 21 7.5 7.5 21 3 16.5z" />
        <path d="M7 12.5l2 2M10 9.5l2 2M13 6.5l2 2" />
      </>
    ),
    cube: (
      <>
        <path d="M12 2.8l8.5 4.6v9.2L12 21.2 3.5 16.6V7.4L12 2.8z" />
        <path d="M3.5 7.4L12 12l8.5-4.6M12 12v9.2" />
      </>
    ),
    brick: (
      <>
        <rect x="3" y="5" width="18" height="5" />
        <rect x="3" y="14" width="18" height="5" />
        <path d="M9 5v5M15 14v5" />
      </>
    ),
    shield: (
      <>
        <path d="M12 3l7 3v5.5c0 4.3-3 7.7-7 9.5-4-1.8-7-5.2-7-9.5V6l7-3z" />
        <path d="M9 12l2.2 2.2L15.5 10" />
      </>
    ),
    crane: (
      <>
        <path d="M4 21h16M6 21V6l12-1" />
        <path d="M6 6h12M13 5v5M11 10h4" />
      </>
    ),
    briefcase: (
      <>
        <rect x="3" y="7.5" width="18" height="12" rx="1.5" />
        <path d="M9 7.5V5.5h6v2M3 12.5h18" />
      </>
    ),
  };
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      {p[type] ?? p["compass"]}
    </svg>
  );
}

const isSub = (t) => /^[A-Z]\.\s/.test(t);

function ModuleGroup({ item, index, open, onToggle }) {
//   const topicCount = item.blocks.reduce(
//     (n, b) => n + (b.type === "software-groups" ? b.groups.reduce((m, g) => m + g.tools.length, 0) : (b.items ? b.items.length : 0)),
//     0
//   );

const topicCount = item.blocks.reduce(
  (n, b) => {
    if (b.type === "software-groups") {
      return n + b.groups.reduce((m, g) => m + g.tools.length, 0);
    }
    if (b.heading === "What They'll Learn") {
      return n;
    }
    return n + (b.items ? b.items.length : 0);
  },
  0
);

  return (
    <div className={`csg-group${open ? " open" : ""}`}>
      <button type="button" className="csg-header" onClick={onToggle} aria-expanded={open}>
        <span className="csg-header-icon">
          <ModuleIcon type={item.icon} />
        </span>
        <span className="csg-header-text">
          <span className="csg-title">{item.title}</span>
          <span className="csg-meta">
            <span className="csg-dur">{item.duration}</span>
            <span className="csg-count">{topicCount} topics</span>
          </span>
        </span>
        <span className="csg-line" />
        <span className="csg-toggle">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 5v14M5 12h14" />
          </svg>
        </span>
      </button>

      <div className="csg-body" style={{ maxHeight: open ? "3000px" : undefined }}>
        <div className="csg-body-inner">
          {item.blocks.map((block, bi) => {
            // Grouped software cards (category headers + tool grid),
            // used only by the "Advance Architecture Softwares" module.
            if (block.type === "software-groups") {
              return (
                <div className="csg-card csg-card--software" key={`sw-${bi}`}>
                  <SoftwareGroups groups={block.groups} />
                </div>
              );
            }

            // Every other block (Program structure / Course Objectives /
            // Services / notes-only blocks) now renders with the exact
            // same category-header + card-grid treatment as the software
            // groups above, via ItemBlockGroup.
            return (
              <div className="csg-card csg-card--items" key={`${block.heading ?? "block"}-${bi}`}>
                <ItemBlockGroup heading={block.heading} note={block.note} items={block.items} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function CourseStructureSection() {
  const [open, setOpen] = useState(0);

  return (
    <section className="csg" id="structure">
      <style>{`
        // .csg {
        //   --csg-ink: var(--charcoal, #1c1a17);
        //   --csg-ink-soft: var(--stone, #7d766c);
        //   --csg-paper: var(--cream, #faf9f6);
        //   --csg-card: #ffffff;
        //   --csg-line: var(--sand, #e7e1d8);
        //   --csg-accent: var(--terra, #b85c28);
        //   --csg-accent-soft: rgba(184, 92, 40, 0.1);
        //   --csg-accent-deep: var(--terra, #b85c28);
        //   --csg-shadow: 0 1px 2px rgba(18,19,15,0.04), 0 12px 32px -16px rgba(18,19,15,0.14);
        //   --csg-shadow-hover: 0 4px 10px rgba(18,19,15,0.06), 0 24px 48px -18px rgba(184,92,40,0.28);
        //   background: var(--csg-paper);
        //   padding: 96px 32px 112px;
        // }

        .csg {
  --csg-ink: var(--charcoal, #1c1a17);
  --csg-ink-soft: var(--stone, #7d766c);
  --csg-paper: var(--cream, #faf9f6);
  --csg-card: #ffffff;
  --csg-line: var(--sand, #e7e1d8);
  --csg-accent: var(--terra, #b85c28);
  --csg-accent-soft: rgba(184, 92, 40, 0.1);
  --csg-accent-deep: var(--terra, #b85c28);
  --csg-shadow: 0 1px 2px rgba(18,19,15,0.04), 0 12px 32px -16px rgba(18,19,15,0.14);
  --csg-shadow-hover: 0 4px 10px rgba(18,19,15,0.06), 0 24px 48px -18px rgba(184,92,40,0.28);
//   background: var(--csg-paper);
  max-width: 1400px;
  margin: 0 auto;
  padding: 96px 2.5rem 112px;
}
.csg-inner { max-width: none; margin: 0; }

/* Accordion list — 70% width on desktop, full width on mobile */
.csg-list-wrap { width: 100%; }

@media (min-width: 1024px) {
  .csg-list-wrap { width: 70%; }
}

        // .csg-inner { max-width: 1180px; margin: 0 auto; }
        // @media (min-width: 1024px) {
        //   .csg-inner { max-width: 900px; margin: 0; }
        // }

                  background: var(--csg-paper);
          padding: 96px 2.5rem 112px;
        }
        .csg-inner { max-width: 1400px; margin: 0 auto; }

        .csg-lead {
          font-size: 17px; line-height: 1.7; color: var(--csg-ink-soft);
          max-width: 680px; margin: 0 0 64px;
        }

        .csg-group {
          margin-bottom: 16px;
          background: var(--csg-card);
          border: 1px solid var(--csg-line);
          border-radius: 8px;
          box-shadow: var(--csg-shadow);
          overflow: hidden;
          transition: border-color .3s ease, box-shadow .3s ease;
        }
        .csg-group.open {
          border-color: color-mix(in oklab, var(--csg-accent) 35%, var(--csg-line));
          box-shadow: 0 18px 44px -28px rgba(18,19,15,.45);
        }

        .csg-header {
          width: 100%; display: flex; align-items: center; gap: 16px;
          padding: 18px 22px;
          background: transparent;
           border: 0;
           border-radius: 8px;
           cursor: pointer; text-align: left;
          font: inherit; position: relative;
        }
        .csg-header-icon {
          width: 42px; height: 42px; flex-shrink: 0;
          border-radius: 10px; background: var(--csg-accent-soft);
          display: flex; align-items: center; justify-content: center;
          color: var(--csg-accent-deep);
          transition: background .25s ease, color .25s ease;
        }
        .csg-header-icon svg { width: 20px; height: 20px; }
        .csg-group.open .csg-header-icon { background: var(--csg-accent-deep); color: #fff; }

        .csg-header-text { min-width: 0; display: flex; flex-direction: column; gap: 4px; }
        .csg-title {
          font-size: 18px; font-weight: 700; letter-spacing: -0.01em;
          color: var(--csg-ink); line-height: 1.25;
        }
        .csg-meta {
          display: flex; align-items: center; gap: 12px;
          font-size: 12px; font-weight: 600; letter-spacing: 0.04em;
          text-transform: uppercase; color: var(--csg-ink-soft);
        }
        .csg-dur { color: var(--csg-accent-deep); }
        .csg-count { position: relative; padding-left: 14px; }
        .csg-count::before {
          content: ""; position: absolute; left: 0; top: 50%; transform: translateY(-50%);
          width: 4px; height: 4px; border-radius: 50%; background: var(--csg-line);
        }

        .csg-line { flex: 1; height: 1px; background: transparent; margin: 0 6px; }

        .csg-toggle {
          width: 32px; height: 32px; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          border: 1px solid var(--csg-line); color: var(--csg-ink-soft);
          border-radius: 50%;
          transition: transform .3s ease, background .25s ease, color .25s ease, border-color .25s ease;
        }
        .csg-toggle svg { width: 14px; height: 14px; }
        .csg-group.open .csg-toggle {
          transform: rotate(135deg); background: var(--csg-accent);
          border-color: var(--csg-accent); color: #fff;
        }

        .csg-body { max-height: 0; overflow: hidden; transition: max-height .45s cubic-bezier(.4,0,.2,1); }
        .csg-body-inner {
          padding: 0 22px 28px;
          display: flex; flex-direction: column; gap: 16px;
        }

        .csg-card {
          position: relative;
          background: var(--csg-card);
        //   border: 1px solid var(--csg-line);
        //   border-left: 3px solid transparent;
          border-radius: 0;
          padding: 18px 20px;
        //   box-shadow: var(--csg-shadow);
          transition: transform .3s cubic-bezier(.2,.8,.2,1), box-shadow .3s cubic-bezier(.2,.8,.2,1), border-color .3s ease;
          overflow: hidden;
        }
        .csg-card::after {
          content: ""; position: absolute; inset: 0;
        //   background: linear-gradient(90deg, var(--csg-accent-soft), transparent 55%);
          opacity: 0; transition: opacity .3s ease; pointer-events: none;
        }
        .csg-card:hover {
        //   transform: translateX(5px);
        //   box-shadow: var(--csg-shadow-hover);
          border-left-color: var(--csg-accent);
        }
        .csg-card:hover::after { opacity: 1; }

        .csg-card-head {
          position: relative; z-index: 1;
          display: flex; align-items: center; gap: 10px;
          font-size: 13px; font-weight: 700; letter-spacing: 0.04em;
          text-transform: uppercase; color: var(--csg-accent-deep);
          margin-bottom: 12px;
        }
        .csg-card-mark svg { width: 16px; height: 16px; display: block; }
        .csg-card-note {
          position: relative; z-index: 1;
          margin: -4px 0 14px; color: var(--csg-ink-soft);
          font-size: 13px; line-height: 1.6;
        }

        .csg-note {
          margin-top: 52px;
          background: linear-gradient(135deg, var(--csg-accent-deep), var(--csg-accent));
          border-radius: 20px;
          padding: 32px 36px;
          color: #fdfdf9;
          display: flex; align-items: center; gap: 20px;
        }
        .csg-note-icon {
          width: 44px; height: 44px; border-radius: 50%;
          background: rgba(255,255,255,0.16);
          display: flex; align-items: center; justify-content: center;
          font-size: 20px; flex: none;
        }
        .csg-note p { margin: 0; font-size: 16px; line-height: 1.65; font-weight: 500; max-width: 760px; }
        .csg-note strong { font-weight: 700; }

        /* ── Category-header + card-grid treatment, shared by the
           software groups AND every plain item block (Program
           structure / Course Objectives / Services / etc.) ── */
        .csg-card--software,
        .csg-card--items { padding: 20px; }
        .sw-groups { display: flex; flex-direction: column; gap: 22px; }
        .sw-cat-header { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
        .sw-cat-icon {
          width: 30px; height: 30px; flex-shrink: 0;
          background: var(--csg-accent-soft); color: var(--csg-accent-deep);
          border-radius: 8px; display: flex; align-items: center; justify-content: center;
        }
        .sw-cat-icon svg { width: 15px; height: 15px; }
        .sw-cat-title { font-size: 14px; font-weight: 700; color: var(--csg-ink); white-space: nowrap; }
        .sw-cat-line { flex: 1; height: 1px; background: var(--csg-line); }
        .sw-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
        .sw-card {
          display: flex; align-items: center; gap: 12px;
          background: #fff;
           border-top:none;
           border-left:none;
           border-right:none;
           border-bottom:1px solid var(--csg-line);
           padding: 6px 10px;
        }

        .sw-card-icon {
          width: 24px; height: 24px; flex-shrink: 0; border-radius: 9px;
          display: flex; align-items: center; justify-content: center;
        }
        .sw-card-icon svg { width: 17px; height: 17px; }
        .sw-card-text { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
        .sw-card-title { font-size: 14px; font-weight: 700; color: var(--csg-ink); }
        .sw-card-sub { font-size: 12px; color: var(--csg-ink-soft); font-weight: 400; }
        @media (max-width: 640px) {
          .sw-grid { grid-template-columns: 1fr; }
        }

        /* Advance Architecture Softwares — tool cards (SoftwareGroups)
           get a border on all four sides, unlike the bottom-only
           treatment used by the item-block checkmark cards. */
        .csg-card--software .sw-card {
          border: 1px solid var(--csg-line);
          border-radius: 6px;
        }

        /* Item cards (Program structure / Course Objectives / Services)
           reuse .sw-card's shape, with an accent-tinted icon chip.
           Sub-items (A. / B. / C. lines) render with NO leading icon
           and stack one under the other (full-width row), with just a
           bottom border — no all-around box. */
        .csg-item-card { align-items: flex-start; }
        .csg-item-icon {
          background: var(--csg-accent-soft);
          color: var(--csg-accent-deep);
        }
        .csg-item-card.sub {
          grid-column: 1 / -1;
          background: transparent;
          border: none;
          border-bottom: 1px solid var(--csg-line);
          padding: 10px 2px;
        }
        .csg-item-text {
          font-size: 13.5px;
          line-height: 1.5;
          font-weight: 400;
          white-space: normal;
        }

        @media (max-width: 900px) {
          .csg-body-inner { grid-template-columns: 1fr; }
        }
        @media (max-width: 640px) {
          .csg { padding: 64px 20px 72px; }
          .csg-header { padding: 16px 18px; gap: 12px; }
          .csg-header-icon { width: 36px; height: 36px; }
          .csg-header-icon svg { width: 18px; height: 18px; }
          .csg-title { font-size: 16px; }
          .csg-meta { font-size: 11px; }
          .csg-body-inner { padding: 0 18px 22px; gap: 12px; }
          .csg-card { padding: 16px; }
          .csg-note { flex-direction: column; align-items: flex-start; padding: 28px 24px; }
        }
      `}</style>
      <div className="csg-inner">
        <div className="eyebrow rv">
          <div className="eyebrow-dash" />
          <span className="eyebrow-text">Program Curriculum</span>
        </div>
        <h2 className="sec-title rv d1">
          Course <em>Structure</em>
        </h2>
        <p className="csg-lead">
          Eight modules of best-in-class content by leading faculty and industry leaders — expand each module to see topics, objectives, and outcomes.
        </p>

        <div className="csg-list-wrap">
          {courseStructure.map((item, i) => (
            <ModuleGroup
              key={item.title}
              item={item}
              index={i}
              open={open === i}
              onToggle={() => setOpen(open === i ? -1 : i)}
            />
          ))}
        </div>

        {/* <div className="csg-note">
          <div className="csg-note-icon">✦</div>
          <p>
            <strong>Your learning journey is hands-on.</strong> Each module builds toward the live project enrolment, where you work on real sites from scratch to handover.
          </p>
        </div> */}
      </div>
    </section>
  );
}


function ExecutiveArchitectPage() {
  const [activeTab, setActiveTab] = useState(getTabFromHash);
  const [openHighlight, setOpenHighlight] = useState(-1);
  const [activeSteps, setActiveSteps] = useState(1);
  const [brochureEmail, setBrochureEmail] = useState("");
  const [brochurePhone, setBrochurePhone] = useState("");
  const [brochureLabel, setBrochureLabel] = useState("Download Brochure");
  const [brochureBusy, setBrochureBusy] = useState(false);
  const revealRef = useRef(null);
  const lpeTimerRef = useRef(null);
  const lpeAnimatedRef = useRef(false);
  const tabsWrapRef = useRef(null);
  const tabsSentinelRef = useRef(null);
  const [tabsPinned, setTabsPinned] = useState(false);
  const [tabsHeight, setTabsHeight] = useState(0);
  // Guards the scroll-spy from fighting a click-triggered smooth scroll.
  const isProgrammaticScrollRef = useRef(false);
  const programmaticScrollTimerRef = useRef(null);

  useEffect(() => { document.title = "Executive Architect - IPDI"; }, []);

  useEffect(() => {
    const getHeaderOffset = () =>
      window.matchMedia("(max-width: 700px)").matches ? 56 : 64;

    const updateTabsState = () => {
      if (!tabsSentinelRef.current || !tabsWrapRef.current) {
        return;
      }

      setTabsHeight(tabsWrapRef.current.offsetHeight);
      setTabsPinned(tabsSentinelRef.current.getBoundingClientRect().top <= getHeaderOffset());
    };

    updateTabsState();
    window.addEventListener("scroll", updateTabsState, { passive: true });
    window.addEventListener("resize", updateTabsState);
    return () => {
      window.removeEventListener("scroll", updateTabsState);
      window.removeEventListener("resize", updateTabsState);
    };
  }, []);

  // Sync tab on browser back/forward
  useEffect(() => {
    const onPopState = () => {
      setActiveTab(getTabFromHash());
    };
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  // Reveal animation — runs once on mount now that every section is always in the DOM.
  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(".rv"));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  // Scroll-spy — keeps the tab bar's active/underline state in sync while the
  // user scrolls the single long page, instead of switching content in/out.
  useEffect(() => {
    // const sectionIds = ["overview", "structure", "instructors", "admissions"];
    const sectionIds = ["overview", "structure", "instructors", "outcome", "admissions", "enroll"];
    const sections = sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    if (sections.length === 0) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (isProgrammaticScrollRef.current) return;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveTab(entry.target.id);
          }
        });
      },
      { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
    );
    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  // Tab click — scroll smoothly to the matching section on this same page,
  // update the URL hash, and mark that tab active immediately (scroll-spy
  // takes back over once the smooth scroll settles).

  const handleTabClick = (event, tabId) => {
    event.preventDefault();

    // if (tabId === "enroll") {
    //   setActiveTab("enroll");
    //   window.history.pushState(null, "", "#admissions");
    //   window.requestAnimationFrame(() => {
    //     const target = document.getElementById("apply") || document.getElementById("admissions");
    //     if (!target) return;

    if (tabId === "enroll") {
  setActiveTab("enroll");
  window.history.pushState(null, "", "#enroll");
  window.requestAnimationFrame(() => {
    const target = document.getElementById("apply") || document.getElementById("enroll");
    if (!target) return;
        const headerOffset = window.matchMedia("(max-width: 700px)").matches ? 56 : 64;
        const tabsOffset = tabsWrapRef.current ? tabsWrapRef.current.offsetHeight : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - tabsOffset - 18;

        isProgrammaticScrollRef.current = true;
        window.scrollTo({ top, behavior: "smooth" });

        if (programmaticScrollTimerRef.current) {
          window.clearTimeout(programmaticScrollTimerRef.current);
        }
        programmaticScrollTimerRef.current = window.setTimeout(() => {
          isProgrammaticScrollRef.current = false;
        }, 900);
      });
      return;
    }

    setActiveTab(tabId);
    window.history.pushState(null, "", `#${tabId}`);

    const targetEl = document.getElementById(tabId);
    if (!targetEl) return;

    const getHeaderOffset = () =>
      window.matchMedia("(max-width: 700px)").matches ? 56 : 64;
    const tabsOffset = tabsWrapRef.current ? tabsWrapRef.current.offsetHeight : 0;
    const top =
      targetEl.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - tabsOffset;

    isProgrammaticScrollRef.current = true;
    window.scrollTo({ top, behavior: "smooth" });

    if (programmaticScrollTimerRef.current) {
      window.clearTimeout(programmaticScrollTimerRef.current);
    }
    // Give the smooth scroll time to finish before letting the scroll-spy
    // observer take control of activeTab again.
    programmaticScrollTimerRef.current = window.setTimeout(() => {
      isProgrammaticScrollRef.current = false;
    }, 900);
  };

  // On first load, if the URL already has a hash (e.g. shared link to
  // #admissions), jump straight to that section once everything is mounted.
  useEffect(() => {
    const initialTab = getTabFromHash();
    if (initialTab === "overview") return;
    const targetEl = document.getElementById(initialTab);
    if (!targetEl) return;

    const getHeaderOffset = () =>
      window.matchMedia("(max-width: 700px)").matches ? 56 : 64;
    const tabsOffset = tabsWrapRef.current ? tabsWrapRef.current.offsetHeight : 0;
    const top =
      targetEl.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - tabsOffset;

    window.scrollTo({ top, behavior: "auto" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBrochureDownload = () => {
    if (!brochureEmail || !brochureEmail.includes("@")) return;
    setBrochureBusy(true);
    setBrochureLabel("Sending...");
    window.setTimeout(() => {
      setBrochureBusy(false);
      setBrochureLabel("Sent! Check your inbox");
      window.setTimeout(() => setBrochureLabel("Download Brochure"), 3000);
    }, 900);
  };

  return (
    <main className="public-page architect-theme architect-page">
      <style>{`
        @media (min-width: 1200px) {
          .architect-theme.architect-page .info-bar {
            left: 50%;
            right: auto;
            width: min(1300px, calc(100vw - 6rem));
            max-width: 1400px;
            margin-left: 0;
            margin-right: 0;
            margin-top:20px;
            margin-bottom: 50px;
            transform: translate(-50%, 1%);
          }
        }
      `}</style>

      {/* ── Hero — always visible ── */}
      <section className="chero">
        <div className="chero-grid" />
        <div className="chero-glow" />
        <div className="chero-inner">
          <div className="chero-kicker rv" style={{ color: "#c84b20" }}>
            Professional Training Program
          </div>
          <div className="chero-title-wrap rv d1">
            <div className="chero-title-bar" />
            <h1 className="chero-title">  Executive <span
             style={{  color: "#c84b20" }}>Architect</span>
            </h1>
          </div>

 <p className="chero-italic rv d1">Become an Industry-Ready Architect</p>


          <p className="chero-sub rv d2">
         Software is a tool. Leadership, execution, and design thinking make an architect. Gain the skills to confidently lead projects from concept to completion.
          </p>
          <div className="chero-actions rv d3">
            <a
              href="#admissions"
              className="btn btn-terra"
              onClick={(event) => handleTabClick(event, "admissions")}
            >
            Start your Application
              <svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2" width="13" height="13">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <div className="chero-soon">
              <span className="chero-soon-dot" />
              Starting Soon - Aug 2026 Batch
            </div>
          </div>
        </div>

        <div className="info-bar rv d4">
          <div className="info-item">
            <div className="info-icon"><HeroIcon type="eligibility" /></div>
            <div className="info-lbl">Eligibility</div>
            <div className="info-val">Bachelor of Architecture</div>
          </div>
          <div className="info-item">
            <div className="info-icon"><HeroIcon type="duration" /></div>
            <div className="info-lbl">Duration</div>
            <div className="info-val">6 Months</div>
            <div className="info-sub">Recommended 15 hrs/week</div>
          </div>
          <div className="info-item">
            <div className="info-icon"><HeroIcon type="classes" /></div>
            <div className="info-lbl">Classes</div>
            <div className="info-val">Virtual Classrooms</div>
            <div className="info-sub">Live interactions &amp; coaching</div>
          </div>
        </div>
      </section>

      {/* ── Tabs — always visible, sticky/pinned. Clicking now scrolls
          within this same page instead of swapping mounted content. ── */}
      <div ref={tabsSentinelRef} className="tabs-sentinel" />
      <div
        className={`tabs-wrap${tabsPinned ? " is-tabs-fixed" : ""}`}
        ref={tabsWrapRef}
        style={{ background: "#0a0908" }}
      >
        <div className="tabs">
          {[
            ["overview", "Overview"],
            ["structure", "Course Structure"],
            ["instructors", "Instructors"],
            ["outcome", "Outcome"],
            ["admissions", "Admissions"],
             ["enroll", "Enroll"],
          ].map(([id, label]) => (
            <a
              key={id}
              href={`#${id}`}
              className={`tab-link${activeTab === id ? " active" : ""}`}
              onClick={(event) => handleTabClick(event, id)}
            >
              {label}
            </a>
          ))}
        </div>
      </div>

      {/* ══════════════════════════════════════
          OVERVIEW SECTION — always rendered
      ══════════════════════════════════════ */}
      <div id="overview">


        {/* Key Highlights */}
        <section className="highlights hl-highlights-section" >
          <style>{`
            .hl-highlights-grid {
              display: flex;
              gap: 60px;
              align-items: start;
            }

            /* ── Column 1: Key Highlights (70%) ── */
            .hl-highlights-section .hl-accordion {
              flex: 0 0 calc(65% - 0.875rem);
              width: auto;
              max-width: 100%;
              box-sizing: border-box;
            }
            .hl-highlights-section .hl-item,
            .hl-highlights-section .hl-q,
            .hl-highlights-section .hl-a {
              box-sizing: border-box;
              max-width: 100%;
            }
            .hl-highlights-section .hl-item:first-child .hl-a-inner {
              max-width: none;
            }

            /* ── Column 2: At a Glance (30%) ── */
            .hl-at-glance {
              flex: 0 0 calc(30% - 0.875rem);
              width: auto;
              background: #fdfcfa;
              border: 1px solid var(--sand);
              padding: 2.2rem 2rem;
              margin-top: 105px;
            }
            .hl-at-glance-top {
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            .hl-at-glance-eyebrow {
              font-family: var(--mono);
              font-size: 0.78rem;
              letter-spacing: 0.1em;
              text-transform: uppercase;
              color: var(--terra);
            }
            .hl-at-glance-pulse {
              width: 7px;
              height: 7px;
              border-radius: 50%;
              background: var(--terra);
              animation: ipdw-pulse 1.8s ease-in-out infinite;
            }
            @keyframes ipdw-pulse {
              0%, 100% { opacity: 1; box-shadow: 0 0 0 0 rgba(184,92,40,0.5); }
              50% { opacity: 0.6; box-shadow: 0 0 0 5px rgba(184,92,40,0); }
            }
            .hl-at-glance-row {
              display: flex;
              align-items: flex-start;
              gap: 1rem;
              padding: 1.2rem 0;
              border-bottom: 1px solid var(--cream);
            }
            .hl-at-glance-row:last-child { border-bottom: none; }
            .hl-at-glance-icon {
              flex-shrink: 0;
              width: 40px;
              height: 40px;
              background: rgba(184, 92, 40, 0.1);
              border: 1px solid rgba(184, 92, 40, 0.4);
              display: flex;
              align-items: center;
              justify-content: center;
              color: var(--terra);
            }
            .hl-at-glance-icon svg { width: 18px; height: 18px; }
            .hl-at-glance-title {
              font-size: 0.98rem;
              font-weight: 600;
              color: var(--charcoal);
              margin-bottom: 0.3rem;
            }
            .hl-at-glance-sub {
              font-size: 0.8rem;
              font-weight: 300;
              color: var(--stone);
              line-height: 1.45;
            }

            /* ── Stack into one column on smaller screens ── */
            @media (max-width: 760px) {
              .hl-highlights-grid {
                flex-direction: column;
              }
              .hl-highlights-section .hl-accordion {
                flex: 1 1 100%;
                width: 100%;
                max-width: 100%;
              }
              .hl-at-glance {
                flex: 1 1 100%;
                width: 100%;
              }
            }

            @media (max-width: 700px) {
              .architect-theme .hl-highlights-section {
                width: 100%;
                max-width: 100%;
                padding-top: 3rem;
                padding-left: 0;
                padding-right: 0;
              }
              .architect-theme .hl-highlights-section .hl-head {
                max-width: 100%;
                padding-left: 1rem;
                padding-right: 1rem;
                box-sizing: border-box;
              }
              .architect-theme .hl-highlights-section .hl-accordion {
                width: 100%;
                max-width: 100%;
                padding-left: 1rem;
                padding-right: 1rem;
              }
              .architect-theme .hl-highlights-section .hl-q-text {
                font-size: 0.92rem;
              }
              .architect-theme .hl-highlights-section .hl-a-inner {
                max-width: 100%;
                font-size: 0.82rem;
              }
              .architect-theme .hl-highlights-section .hl-item.open .hl-a {
                max-height: 1400px !important;
              }
              .architect-theme .hl-highlights-section .hl-stat-grid {
                grid-template-columns: 1fr;
              }
              .architect-theme .hl-highlights-section .hl-stat-cell {
                padding: 1.4rem 1.5rem;
                min-height: unset;
              }
              .architect-theme .hl-highlights-section .hl-stat-label {
                white-space: normal;
              }
              .architect-theme .hl-at-glance {
                margin-top:0.1rem;
              }
            }

            .chero-italic {
              font-family: var(--serif);
              font-style: italic;
              font-size: clamp(1.15rem, 1.8vw, 1.5rem);
              font-weight: 400;
              color: #c84b20;
              margin-bottom: 2px;
            }

            .architect-theme .info-bar {
              position: absolute;
              bottom: -30px;
              left: 2.5rem;
              right: 2.5rem;
              width: auto;
              max-width: none;
              margin: 0;
              background: #fff;
              z-index: 10;
              box-shadow: 0 4px 12px rgba(0,0,0,0.06);
            }

            @media (max-width: 700px) {
              .architect-theme .info-bar {
                position: relative !important;
                bottom: auto !important;
                left: 0 !important;
                right: 0 !important;
                top: auto !important;
                margin: 1rem auto 0 auto !important;
                transform: none !important;
                box-shadow: 0 4px 12px rgba(0,0,0,0.06);
              }
              .architect-theme .chero {
                padding-bottom: 1rem;
              }
            }
          `}</style>
          <div className="hl-head" style={{ maxWidth: "860px" }}>
            <div className="eyebrow rv">
              <div className="eyebrow-dash" />
              <span className="eyebrow-text">Why This Program</span>
            </div>
            <h2 className="sec-title rv d1" >
              Key <em>Highlights</em>
            </h2>
          </div>

          <div className="hl-highlights-grid">
            {/* ── Column 1 (70%) — Key Highlights accordion ── */}
            <div className="hl-accordion rv d3">
              {highlights.map((item, index) => {
                const isOpen = item.alwaysOpen || openHighlight === index;
                const openHeight = HL_OPEN_HEIGHTS[index];
                return (
                  <div className={`hl-item${isOpen ? " open" : ""}`} key={item.title}>
                    <button
                      type="button"
                      className="hl-q"
                      onClick={() => {
                        if (item.alwaysOpen) return;
                        setOpenHighlight(isOpen ? -1 : index);
                      }}
                    >
                      <span className="hl-q-text">{item.title}</span>
                      <div className="hl-icon" style={{ transform: "none" }}>
                        <ChevronIcon open={isOpen} />
                      </div>
                    </button>
                    <div
                      className="hl-a"
                      style={openHeight ? { maxHeight: isOpen ? `${openHeight}px` : undefined } : {}}
                    >
                      <div className="hl-a-inner">{item.detail}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>


 {/* Designed for Practice */}
  <DesignedForPractice />

     {/* Why This Program Is Different */}
        <WhyDifferentSection />

          {/* ══════════════════════════════════════
          COURSE STRUCTURE SECTION —
      ══════════════════════════════════════ */}
      <CourseStructureSection />

 {/* ══════════════════════════════════════
         45days Live Project SECTION —
      ══════════════════════════════════════ */}

        <Liveprojectsection />

 {/* ══════════════════════════════════════
          INSTRUCTORS SECTION —
      ══════════════════════════════════════ */}
      <div id="instructors">
        <Trainers />
      </div>

     

        {/* Growth */}
        <section className="growth" id="outcome" >
          <div className="growth-inner">
            <div className="growth-hdr">
              <div className="rv">
                <div className="eyebrow">
                  <div className="eyebrow-dash" />
                  <span className="eyebrow-text">Growth</span>
                </div>

                <h2 className="sec-title lt"> How This Program Transforms You </h2>
              </div>
              <div className="growth-desc rv d1">
                <p>  More than technical training, this program prepares you to think, work, and perform like a professional architect. Through personalized mentoring, real-world exposure, and industry-driven learning, you'll build the confidence to take on real architectural challenges. </p>
              </div>
            </div>
            <div className="growth-grid rv d2">
              {growthCards.map((card) => (
                <div className="gc" key={card.title}>
                  <div className="gc-icon">{card.icon}</div>
                  <div className="gc-t">{card.title}</div>
                  <p className="gc-d">{card.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <Outcomes />

      </div>

     {/* ══════════════════════════════════════
          Certificate SECTION
      ══════════════════════════════════════ */}
  <CertificateOutcomeSection />


      {/* ══════════════════════════════════════
          ADMISSIONS SECTION — always rendered
      ══════════════════════════════════════ */}
      {/* <div id="admissions">
        <AdmissionProcessSection />
        <AdmissionForm sectionId="admissions" reveal />
      </div> */}

      <div id="admissions">
  <AdmissionProcessSection />
</div>
<AdmissionForm sectionId="enroll" reveal />

    </main>
  );
}

export default ExecutiveArchitectPage;
